import React from "react";
import { Link } from "react-router-dom";
import {
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
  CNavItem,
} from "@coreui/react";

export const SidebarDarkExample = () => {
  return (
    <CSidebar className="border-end" colorScheme="dark">
      <CSidebarHeader>
        <CSidebarBrand>Quản lý nhân sự </CSidebarBrand>
      </CSidebarHeader>
      <CSidebarNav>
        <CNavItem>
          <Link to="/" className="nav-link">
            Biểu đồ
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/#" className="nav-link">
            Admin
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/ds_nhansu" className="nav-link">
            Nhân sự
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/ds_PhongBan" className="nav-link">
            Phòng ban{" "}
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/xem_lich" className="nav-link">
            lịch làm việc{" "}
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/tao_lich" className="nav-link">
            Tạo lịch{" "}
          </Link>
        </CNavItem>
        <CNavItem>
          <Link to="/BangLuong" className="nav-link"></Link>
        </CNavItem>
      </CSidebarNav>
    </CSidebar>
  );
};
